export const EMAIL = "soundbyrachel@gmail.com";
export const ALIGNMENT_CLASSES = "container mx-auto px-5 max-w-[1140px]";
